import { FormErrorCode } from '@bit-box/common';

/**
 * FormErrorCode에 대응하는 한국어 에러 메시지
 * {key} 형태의 플레이스홀더는 ctx 값으로 치환됩니다.
 */
export const FormErrorMessages: Record<FormErrorCode, string> = {
  // 신호 관련
  [FormErrorCode.SIGNAL_NOT_SELECTED]: '신호를 선택해주세요.',
  [FormErrorCode.SIGNAL_NO_CONDITIONS]: '[{signalTypeName}] 신호 타입은 조건을 하나도 가지고 있지 않습니다.',
  [FormErrorCode.SIGNAL_DUPLICATE]: '신호가 중복되었습니다.',

  // 수량/비율 관련
  [FormErrorCode.AMOUNT_INVALID]: '수량은 0 이상 100 이하의 유효한 숫자여야 합니다.',
  [FormErrorCode.AMOUNT_RATIO_INVALID]: '청산 비율은 0 이상 100 이하의 유효한 숫자여야 합니다.',
  [FormErrorCode.ENTER_AMOUNT_SUM_NOT_100]: '{triggerType}에서 진입 수량 비율의 합은 100%가 되어야 합니다.',
  [FormErrorCode.EXIT_LAST_AMOUNT_NOT_100]: '청산 마지막 단계의 청산 비율은 100%로 고정되어야 합니다.',
  [FormErrorCode.LAST_AMOUNT_NOT_100]: '마지막 단계의 청산 비율은 100%로 고정되어야 합니다.',

  // 추적 청산 관련
  [FormErrorCode.TRAILING_CHANGE_INVALID]: '기준값은 양수여야 합니다.',

  // 구간 청산 관련
  [FormErrorCode.EXCLUSIVE_CHANGE_INVALID]: '{triggerType}에서 순익률값은 빈값이거나 0일 수 없습니다.',
  [FormErrorCode.STOPLOSS_REQUIRED]: '손절 구간은 반드시 1개 이상이어야 합니다.',
  [FormErrorCode.STOPLOSS_FIRST_AMOUNT_NOT_100]: '손절의 첫구간 수량 비율은 100%로 고정되어야 합니다.',
  [FormErrorCode.TAKEPROFIT_LAST_AMOUNT_NOT_100]:
    '추적 청산 단계가 없으면 익절의 마지막 구간 청산 비율은 100% 이어야 합니다.',

  // 단계 청산 관련
  [FormErrorCode.OVERLAPPING_VALUE_INVALID]: '단계 청산 구간에서 모든 입력값은 유효한 숫자여야 합니다.',
  [FormErrorCode.OVERLAPPING_AMOUNT_INVALID]:
    '단계 청산 구간에서 청산 비율은 0 이상 100 이하의 유효한 숫자여야 합니다.',
  [FormErrorCode.OVERLAPPING_AMOUNT_EXCEED]: '단계 청산 구간에서 청산 비율은 100을 초과할 수 없습니다.',
  [FormErrorCode.OVERLAPPING_UP_GREATER_THAN_DOWN]: '동일 구간의 상승 시 수익률은 하락 시 수익률보다 커야 합니다.',
  [FormErrorCode.OVERLAPPING_DOWN_ORDER_INVALID]:
    '하락 시 수익률은 이전 구간의 상승 시 수익률보다 같거나 작아야 합니다.',
  [FormErrorCode.OVERLAPPING_UP_ORDER_INVALID]: '상승 시 수익률은 이전 구간의 상승 시 수익률보다 커야 합니다.',
  [FormErrorCode.OVERLAPPING_FIRST_DOWN_AMOUNT_NOT_100]: '첫 번째 하락 시 청산 비율은 100% 이어야 합니다.',
  [FormErrorCode.OVERLAPPING_LAST_UP_AMOUNT_NOT_100]:
    '추적 청산 단계가 없으면 마지막 상승 시 청산 비율은 100% 이어야 합니다.',

  // 조건 관련
  [FormErrorCode.CONDITION_ID_DUPLICATE]: '조건 ID({conditionId})가 이미 존재합니다.',

  // 지표 관련
  [FormErrorCode.INDICATOR_TIMEFRAME_REQUIRED]: 'Timeframe을 선택해주세요.',
};
